import anchor from "../svg/anchor.svg" with { type: "text" };
import alertCircle from "../svg/alert-circle.svg" with { type: "text" };
import assorted from "../svg/assorted.svg" with { type: "text" };
import bookOpen from "../svg/book-open.svg" with { type: "text" };
import check from "../svg/check.svg" with { type: "text" };
import chevronDown from "../svg/chevron-down.svg" with { type: "text" };
import chevronLeft from "../svg/chevron-left.svg" with { type: "text" };
import chevronRight from "../svg/chevron-right.svg" with { type: "text" };
import chevronUp from "../svg/chevron-up.svg" with { type: "text" };
import circle from "../svg/circle.svg" with { type: "text" };
import circleFull from "../svg/circle-full.svg" with { type: "text" };
import download from "../svg/download.svg" with { type: "text" };
import edit from "../svg/edit.svg" with { type: "text" };
import externalLink from "../svg/external-link.svg" with { type: "text" };
import folder from "../svg/folder.svg" with { type: "text" };
import folderMinus from "../svg/folder-minus.svg" with { type: "text" };
import folderPlus from "../svg/folder-plus.svg" with { type: "text" };
import globe from "../svg/globe.svg" with { type: "text" };
import helpCircle from "../svg/help-circle.svg" with { type: "text" };
import layers from "../svg/layers.svg" with { type: "text" };
import logOut from "../svg/log-out.svg" with { type: "text" };
import moreHorizontal from "../svg/more-horizontal.svg" with { type: "text" };
import plus from "../svg/plus.svg" with { type: "text" };
import rotateCw from "../svg/rotate-cw.svg" with { type: "text" };
import rss from "../svg/rss.svg" with { type: "text" };
import search from "../svg/search.svg" with { type: "text" };
import sliders from "../svg/sliders.svg" with { type: "text" };
import star from "../svg/star.svg" with { type: "text" };
import starFull from "../svg/star-full.svg" with { type: "text" };
import trash from "../svg/trash.svg" with { type: "text" };
import upload from "../svg/upload.svg" with { type: "text" };
import x from "../svg/x.svg" with { type: "text" };

export default {
  anchor,
  "alert-circle": alertCircle,
  assorted,
  "book-open": bookOpen,
  check,
  "chevron-down": chevronDown,
  "chevron-left": chevronLeft,
  "chevron-right": chevronRight,
  "chevron-up": chevronUp,
  circle,
  "circle-full": circleFull,
  download,
  edit,
  "external-link": externalLink,
  folder,
  "folder-minus": folderMinus,
  "folder-plus": folderPlus,
  globe,
  "help-circle": helpCircle,
  layers,
  "log-out": logOut,
  "more-horizontal": moreHorizontal,
  plus,
  "rotate-cw": rotateCw,
  rss,
  search,
  sliders,
  star,
  "star-full": starFull,
  trash,
  upload,
  x,
};
